import React, { useState, useEffect } from "react";
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useUser } from '../../contexts/UserContext';


const GoogleBtn = ({ disabled=false, mode='login', showAlert}) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);

  const { socialLogin } = useUser();

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => {
      showAlert(`Login Failed: ${error.message}`);
    }
  });

  useEffect(() => {
    if (user) {
      axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
            Accept: 'application/json',
          }
        })
        .then((res) => setProfile(res.data))
        .catch((err) => showAlert(`Google API Error: ${err.message}`));
    }
  }, [user]);

  useEffect(() => {
    if (profile) {
      const handleSocialLogin = async () => {
        try {
          
          // Extract info from profile
          const loginPayload = {
            fullName:profile.name,
            email: profile.email,        
            picture:profile.picture,
            password:profile.id,
            auth: "GOOGLE",
          };
          
          await socialLogin(mode, loginPayload);
        } catch (err) {
          showAlert(err.message);
        }
      };

      handleSocialLogin();
    }
  }, [profile, socialLogin]);

  return (
    <button
      onClick={googleLogin}
      disabled={disabled}
      className="w-full flex items-center justify-center gap-2 py-3 px-4 bg-white text-gray-800 border border-gray-300 rounded-lg shadow-sm hover:shadow-md"
    >
      <img src="/google_icon.svg" alt="Google" className="w-5 h-5" />
      התחבר באמצעות גוגל
    </button>
  );
};

export default GoogleBtn;
